/* Guided-flow steps (DESIGN_SYSTEM §6). Logical properties only. */
.stepper {
  min-inline-size: 0;
}

.list {
  display: flex;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  flex: 1 1 0;
  min-inline-size: 0;
}

.step {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  inline-size: 100%;
  min-block-size: 3rem;
  padding: var(--space-2) var(--space-3);
  border: var(--border-width) solid var(--color-border);
  border-block-end-width: 3px;
  border-radius: var(--radius-md);
  background: var(--color-surface);
  color: var(--color-text-muted);
  font: inherit;
  font-weight: var(--weight-medium);
  text-align: start;
  cursor: pointer;
  transition:
    border-color var(--duration-fast) var(--ease-out),
    background-color var(--duration-fast) var(--ease-out);
}

.step:hover {
  background: var(--color-surface-hover);
}

.step[aria-current='step'] {
  border-color: var(--color-primary);
  background: var(--color-primary-subtle);
  color: var(--color-primary-subtle-text);
}

.number {
  flex: none;
  display: inline-grid;
  place-items: center;
  inline-size: 1.75rem;
  block-size: 1.75rem;
  border-radius: 50%;
  border: 1.5px solid currentColor;
  font-variant-numeric: tabular-nums;
  font-weight: var(--weight-bold);
}

.step[aria-current='step'] .number {
  border-color: var(--color-primary);
  background: var(--color-primary);
  color: var(--color-on-primary);
}

.title {
  flex: 1;
  min-inline-size: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--color-heading);
}

.state {
  flex: none;
  display: inline-grid;
  place-items: center;
  min-inline-size: 1.375rem;
  block-size: 1.375rem;
  padding-inline: var(--space-1);
  border-radius: var(--radius-pill);
  font-size: var(--text-xs);
  font-weight: var(--weight-bold);
  font-variant-numeric: tabular-nums;
}

.open {
  background: var(--color-warning-bg);
  color: var(--color-warning-text);
  border: var(--border-width) solid var(--color-warning-border);
}

.clean {
  background: var(--color-success-bg);
  color: var(--color-success-text);
  border: var(--border-width) solid var(--color-success-border);
}

/* Phones: four numbered circles (44 px); only the current step keeps its name; counts as badges. */
@media (max-width: 40rem) {
  .list {
    gap: var(--space-1);
  }

  .item {
    flex: 0 0 auto;
  }

  .item:has([aria-current='step']) {
    flex: 1 1 auto;
  }

  .step {
    min-block-size: 2.75rem;
    min-inline-size: 2.75rem;
    padding: var(--space-1);
    border-block-end-width: var(--border-width);
    border-radius: var(--radius-pill);
  }

  .step:not([aria-current='step']) .title {
    display: none;
  }

  .number {
    inline-size: 2rem;
    block-size: 2rem;
  }

  .state {
    position: absolute;
    inset-block-start: -0.35rem;
    inset-inline-end: -0.35rem;
    min-inline-size: 1.125rem;
    block-size: 1.125rem;
    font-size: 0.625rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .step {
    transition: none;
  }
}
